export const VALID_LEAD_STATUSES = ["open", "hot", "warm", "cold", "won", "lost"];

// Sheet values are often "Hot" / "WARM" / " Cold ". We only keep a known
// CRM status; anything else is dropped so the backend default (open) applies.
export function normalizeLeadStatus(value) {
  const s = String(value ?? "").trim().toLowerCase();
  return VALID_LEAD_STATUSES.includes(s) ? s : undefined;
}
